import React from "react";

import DropdownItem from '../../DropdownItem';
import { dropdownItems } from '../../Content';

const ResourcesDropdown = ({ theme, dropdown, navResponsive }) => (
  <div>
    <div className="p-10" data-first-dropdown-section>
      <div>
        <ul className="grid grid-cols-none gap-y-6">
          {dropdownItems[dropdown].map(item => (
            <DropdownItem
              key={item.title}
              href={item.href}
              icon={item.icon}
              title={item.title}
              text={item.text}
              colors={theme.dropdown.items}
              itemType={item.type}
              navResponsive={navResponsive}
            />
          ))}
        </ul>
      </div>
    </div>
  </div>
)

ResourcesDropdown.defaultProps = {
  dropdown: 'resources',
  navResponsive: false
};

export default ResourcesDropdown
